import { SimpleAnswerEnum } from '../../enums/entity.enum';
import {
  CloseDateTypeEnum,
  CommitmentsTypeEnum,
  PeriodTypeEnum,
  RateIndexEnum,
  SubClInterestIndexEnum,
  MonthEnum,
} from '../../enums/closedEnd.enum';
import { IClosedEndKeyTerm } from '../../interfaces/investment-vehicle/closed-end-key-term.interface';
import {
  StoreModel,
  StoreModelDate,
  StoreModelType,
} from '@aksia/infrastructure';

export class ClosedEndKeyTerm extends StoreModel implements IClosedEndKeyTerm {
  closedEndDataFieldsId: number | undefined = undefined;

  //#region Details Date Info

  effectiveDateType: CloseDateTypeEnum | undefined = undefined;

  @StoreModelType(() => StoreModelDate)
  effectiveDate: Date | undefined = undefined;

  effectiveDateDesc: string | undefined = undefined;

  //#endregion

  //#region Capital Call Procedure / Capital Raise / Fund Terms

  commitmentTarget: number | undefined = undefined;
  hasCommitmentCap: SimpleAnswerEnum | undefined = undefined;
  commitmentCap: number | undefined = undefined;
  commitmentsActual: number | undefined = undefined;
  commitmentsActualType: CommitmentsTypeEnum | undefined = undefined;

  @StoreModelType(() => StoreModelDate)
  commitmentsAsOf: Date | undefined = undefined;
  placementAgent: string | undefined = undefined;
  subsequentCloseInterest: SimpleAnswerEnum | undefined = undefined;
  subsequentCloseInterestType: RateIndexEnum | undefined = undefined;
  subsequentCloseInterestIndex: SubClInterestIndexEnum | undefined = undefined;
  subsequentCloseInterestIndexDesc: string | undefined = undefined;
  subsequentCloseInterestRate: number | undefined = undefined;

  //#endregion

  //#region Fund Timing

  contractualInvestmentPeriodExpirationYears: number | undefined = undefined;
  contractualInvestmentPeriodExpirationType: PeriodTypeEnum | undefined =
    undefined;

  @StoreModelType(() => StoreModelDate)
  contractualInvestmentPeriodExpirationDate: Date | undefined = undefined;
  contractualInvestmentPeriodExpirationDesc: string | undefined = undefined;
  hasContractualInvestmentPeriodUnlimitedExtensions: boolean | undefined =
    undefined;
  contractualTermExpirationYears: number | undefined = undefined;
  contractualTermExpirationType: PeriodTypeEnum | undefined = undefined;

  @StoreModelType(() => StoreModelDate)
  contractualTermExpirationDate: Date | undefined = undefined;
  contractualTermExpirationDesc: string | undefined = undefined;
  hasContractualTermUnlimitedExtensions: boolean | undefined = undefined;

  //#endregion

  //#region Recycling

  hasRecycling: SimpleAnswerEnum | undefined = undefined;
  hasTimeLimit: SimpleAnswerEnum | undefined = undefined;
  hasRecyclingLimit: SimpleAnswerEnum | undefined = undefined;
  recyclingCommitmentsRate: number | undefined = undefined;
  hasProceedsLimit: SimpleAnswerEnum | undefined = undefined;

  //#endregion

  //#region Target Return Profile

  capitalCallLine: SimpleAnswerEnum | undefined = undefined;

  //#endregion

  //#region Structure

  agmTiming: MonthEnum | undefined = undefined;

  //#endregion

  //#region Fund Terms

  oversubscribedFundRaise: SimpleAnswerEnum | undefined = undefined;
  fundCommitmentsTotal: number | undefined = undefined;
  fundCommitmentsLP: number | undefined = undefined;
  fundCommitmentsGP: number | undefined = undefined;

  //#endregion

  //Already exist in meta?
  isDeleted: boolean | undefined = undefined;
  modifiedBy: string | undefined = undefined;
  modifiedOn: Date | undefined = undefined;

  override $onTransform = () => {
    this.subsequentCloseInterestIndex = !this.subsequentCloseInterestIndex
      ? undefined
      : +(this.subsequentCloseInterestIndex as unknown as string);
  };
}
